export interface TopFan {
  id: number;
  name: string;
  photoUrl: string;
  username: string;
  radioId: number;
  radioName: string;
  radioFrequency: string;
  hoursListened: number;
  greetings: number;
  comments: number;
  participations: number;
  requests: number;
  totalScore: number;
  rank: number;
  badge: 'oro' | 'plata' | 'bronce' | 'ninguno';
}

export const topFansRadios: { id: number; name: string; frequency: string }[] = [
  { id: 1, name: 'Radio Éxito FM', frequency: '98.5 FM' },
  { id: 2, name: 'Estéreo Capital', frequency: '102.1 FM' },
  { id: 3, name: 'Radio Deportiva Total', frequency: '95.7 FM' },
  { id: 4, name: 'Radio Élite Digital', frequency: '99.1 FM' },
  { id: 5, name: 'Radio Industria', frequency: '93.5 FM' },
  { id: 6, name: 'Radio Peninsular', frequency: '101.9 FM' },
];

export const topFans: TopFan[] = [
  {
    id: 1,
    name: 'Camila Restrepo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20warm%20friendly%20smile%2C%20casual%20urban%20style%2C%20clean%20soft%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-camila-r&orientation=squarish',
    username: '@camilarestrepo',
    radioId: 1,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    hoursListened: 487,
    greetings: 142,
    comments: 218,
    participations: 34,
    requests: 28,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 2,
    name: 'Andrés Murillo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20confident%20smile%2C%20casual%20hoodie%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-andres-m&orientation=squarish',
    username: '@andresmurillo',
    radioId: 1,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    hoursListened: 412,
    greetings: 98,
    comments: 175,
    participations: 28,
    requests: 15,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 3,
    name: 'Laura Santamaría',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20genuine%20warm%20smile%2C%20casual%20elegant%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-laura-s&orientation=squarish',
    username: '@laurasantamaria',
    radioId: 1,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    hoursListened: 385,
    greetings: 76,
    comments: 142,
    participations: 22,
    requests: 19,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
  {
    id: 4,
    name: 'Felipe Gutiérrez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20charismatic%20expression%2C%20casual%20streetwear%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-felipe-g&orientation=squarish',
    username: '@felipegutierrez',
    radioId: 2,
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    hoursListened: 523,
    greetings: 186,
    comments: 295,
    participations: 42,
    requests: 35,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 5,
    name: 'María José Salazar',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20bright%20friendly%20smile%2C%20trendy%20casual%20look%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-mariajose-s&orientation=squarish',
    username: '@majosalazar',
    radioId: 2,
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    hoursListened: 468,
    greetings: 155,
    comments: 240,
    participations: 36,
    requests: 22,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 6,
    name: 'Daniel Ortega',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20relaxed%20smile%2C%20casual%20t-shirt%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-daniel-o&orientation=squarish',
    username: '@danielortega',
    radioId: 2,
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    hoursListened: 390,
    greetings: 88,
    comments: 168,
    participations: 29,
    requests: 14,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
  {
    id: 7,
    name: 'Javier Mendoza',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20sporty%20look%2C%20energetic%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-javier-m&orientation=squarish',
    username: '@javiermendoza',
    radioId: 3,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    hoursListened: 556,
    greetings: 204,
    comments: 332,
    participations: 48,
    requests: 41,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 8,
    name: 'Paola Rincón',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20sporty%20casual%20style%2C%20confident%20warm%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-paola-r&orientation=squarish',
    username: '@paolarincon',
    radioId: 3,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    hoursListened: 445,
    greetings: 132,
    comments: 210,
    participations: 31,
    requests: 18,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 9,
    name: 'Carlos Herrera',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20friendly%20casual%20smile%2C%20simple%20t-shirt%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-carlos-h&orientation=squarish',
    username: '@carlosherrera',
    radioId: 3,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    hoursListened: 398,
    greetings: 95,
    comments: 155,
    participations: 24,
    requests: 12,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
  {
    id: 10,
    name: 'Isabella Torres',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20stylish%20creative%20look%2C%20warm%20genuine%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-isabella-t&orientation=squarish',
    username: '@isabellatorres',
    radioId: 4,
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    hoursListened: 498,
    greetings: 168,
    comments: 285,
    participations: 38,
    requests: 31,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 11,
    name: 'Santiago López',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20tech%20casual%20style%2C%20friendly%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-santiago-l&orientation=squarish',
    username: '@santilopez',
    radioId: 4,
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    hoursListened: 432,
    greetings: 112,
    comments: 198,
    participations: 27,
    requests: 16,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 12,
    name: 'Valeria Duque',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20creative%20artsy%20style%2C%20warm%20open%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-valeria-d&orientation=squarish',
    username: '@valeriaduque',
    radioId: 4,
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    hoursListened: 375,
    greetings: 82,
    comments: 136,
    participations: 20,
    requests: 11,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
  {
    id: 13,
    name: 'Gabriel Paredes',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20intellectual%20look%2C%20warm%20thoughtful%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-gabriel-p&orientation=squarish',
    username: '@gabrielparedes',
    radioId: 5,
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    hoursListened: 462,
    greetings: 145,
    comments: 260,
    participations: 33,
    requests: 25,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 14,
    name: 'Natalia Córdoba',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20professional%20elegant%20style%2C%20warm%20confident%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-natalia-c&orientation=squarish',
    username: '@nataliacordoba',
    radioId: 5,
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    hoursListened: 405,
    greetings: 108,
    comments: 182,
    participations: 25,
    requests: 17,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 15,
    name: 'Mateo Álvarez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20serious%20engaged%20expression%2C%20casual%20neat%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-mateo-a&orientation=squarish',
    username: '@mateoalvarez',
    radioId: 5,
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    hoursListened: 362,
    greetings: 74,
    comments: 128,
    participations: 18,
    requests: 9,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
  {
    id: 16,
    name: 'Adriana Mejía',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20warm%20nostalgic%20style%2C%20gentle%20genuine%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-adriana-m&orientation=squarish',
    username: '@adrianamejia',
    radioId: 6,
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    hoursListened: 512,
    greetings: 175,
    comments: 248,
    participations: 37,
    requests: 29,
    totalScore: 0,
    rank: 1,
    badge: 'oro',
  },
  {
    id: 17,
    name: 'Roberto Silva',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20warm%20classic%20style%2C%20friendly%20genuine%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-roberto-s&orientation=squarish',
    username: '@robertosilva',
    radioId: 6,
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    hoursListened: 448,
    greetings: 125,
    comments: 195,
    participations: 29,
    requests: 20,
    totalScore: 0,
    rank: 2,
    badge: 'plata',
  },
  {
    id: 18,
    name: 'Carmen Díaz',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20vintage%20chic%20style%2C%20warm%20expressive%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=fan-carmen-d&orientation=squarish',
    username: '@carmendiaz',
    radioId: 6,
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    hoursListened: 392,
    greetings: 92,
    comments: 148,
    participations: 21,
    requests: 13,
    totalScore: 0,
    rank: 3,
    badge: 'bronce',
  },
];

const weights = {
  hoursListened: 0.30,
  greetings: 0.15,
  comments: 0.20,
  participations: 0.20,
  requests: 0.15,
};

const maxValues = {
  hoursListened: 600,
  greetings: 250,
  comments: 400,
  participations: 60,
  requests: 50,
};

function computeScore(fan: Omit<TopFan, 'totalScore'>): number {
  const score =
    (fan.hoursListened / maxValues.hoursListened) * weights.hoursListened * 1000 +
    (fan.greetings / maxValues.greetings) * weights.greetings * 1000 +
    (fan.comments / maxValues.comments) * weights.comments * 1000 +
    (fan.participations / maxValues.participations) * weights.participations * 1000 +
    (fan.requests / maxValues.requests) * weights.requests * 1000;
  return Math.round(score);
}

topFans.forEach((fan) => {
  fan.totalScore = computeScore(fan);
});

export const topFansMetricsSummary = {
  totalFans: 18,
  totalRadios: 6,
  totalHoursListened: 7950,
  totalGreetings: 2257,
  totalComments: 3756,
  totalParticipations: 541,
  totalRequests: 375,
  avgScore: 744,
  topRadio: 'Radio Deportiva Total',
  topFan: 'Javier Mendoza',
};